<template>
  <div id="canvas">
    <div class="turn-viewport">
      <div class="container">
        <template v-if="isMobile()">
          <v-touch @swipeleft="swipeleft" @swiperight="swiperight">
            <div
              class="flipbook"
              :class="{
                ml500: currPage == 1 && !isMobile(),
                mr500: isOddPage && currPage == totalPage && !isMobile(),
              }"
            >
              <div v-for="item in imgList" :key="item">
                <img :src="item" alt="" style="width: 100%; height: 100%" />
              </div>
              <template v-if="!isMobile()">
                <i
                  v-if="currPage > 1"
                  ignore="1"
                  class="el-icon-arrow-left el-icon"
                  style="left: -50px"
                  @click="turnPage('previous')"
                ></i>
                <template v-if="isEvenPage">
                  <i
                    v-if="currPage < totalPage - 1"
                    ignore="1"
                    class="el-icon-arrow-right el-icon"
                    style="right: -50px"
                    @click="turnPage('next')"
                  ></i>
                </template>
                <template v-if="isOddPage">
                  <i
                    v-if="currPage < totalPage"
                    ignore="1"
                    class="el-icon-arrow-right el-icon"
                    style="right: -50px"
                    @click="turnPage('next')"
                  ></i>
                </template>
              </template>
            </div>
          </v-touch>
        </template>
        <template v-else>
          <div
            class="flipbook"
            :class="{
              ml500: currPage == 1 && !isMobile(),
              mr500: isOddPage && currPage == totalPage && !isMobile(),
            }"
          >
            <div v-for="item in imgList" :key="item">
              <img :src="item" alt="" style="width: 100%; height: 100%" />
            </div>
            <i
              v-if="currPage > 1"
              ignore="1"
              class="el-icon-arrow-left el-icon"
              style="left: -50px"
              @click="turnPage('previous')"
            ></i>
            <i
              v-if="isEvenPage && currPage < totalPage - 1"
              ignore="1"
              class="el-icon-arrow-right el-icon"
              style="right: -50px"
              @click="turnPage('next')"
            ></i>
            <i
              v-if="isOddPage && currPage < totalPage"
              ignore="1"
              class="el-icon-arrow-right el-icon"
              style="right: -50px"
              @click="turnPage('next')"
            ></i>
          </div>
        </template>
      </div>
    </div>

    <!--web端上下翻页-->
    <div class="web-bottom">
      <div class="btn-list">
        <i class="el-icon-d-arrow-left" @click="turnPage('first')"></i>
        <i
          id="previous"
          class="el-icon-arrow-left"
          style="margin-left: 10px"
          @click="turnPage('previous')"
        ></i>
        <el-input
          id="pageInput"
          v-model="showPage"
          oninput="if(isNaN(value)) { value  = null }if(!value) { value  = null }if(value.length>3){value=value.slice(0,3)}"
          onkeypress="if(event.keyCode==45||event.keyCode==46||event.keyCode==101){return false}"
          @focus="handleFocus"
          @blur="handleBlur"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-right"
            @click="turnPage('input')"
          ></i>
        </el-input>
        <i id="next" class="el-icon-arrow-right" @click="turnPage('next')"></i>
        <i
          class="el-icon-d-arrow-right"
          style="margin: 0 10px"
          @click="turnPage('last')"
        ></i>
        <i class="el-icon-download" @click="downLoad"></i>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import $ from 'jquery'
  import VueTouch from 'vue-touch'
  Vue.use(VueTouch, { name: 'v-touch' })
  import '../../public/js/turn.js'
  export default {
    props: {
      imgList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        showPage: '1',
        currPage: 1, //当前页
        currPages: [0, 1], //当前页码
        totalPage: 9, //总页数
        isOddPage: false,
        isEvenPage: false,
        imgWidth: '',
        imgHeight: '',
      }
    },
    watch: {
      imgList: {
        handler(newval, oldval) {
          if (newval && newval.length) {
            this.totalPage = newval.length
            this.resetInputPage()
            this.listenerEvents()
            this.$nextTick(() => {
              this.getRatio(newval[0])
            })
          }
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      //判断手机端
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag
      },
      calcHeight() {
        return $(window).height() - 105
      },
      //获取图片像素比
      async getRatio(url) {
        const { width, height } = await this.getImageSize(url)
        this.imgWidth = width
        this.imgHeight = height
        this.initTurn()
      },
      //初始化翻书
      initTurn() {
        $('#canvas').fadeIn(1000)
        var flipbook = $('.flipbook')
        if (flipbook.width() == 0 || flipbook.height() == 0) {
          setTimeout(() => {
            this.init
          }, 10)
          return
        }
        flipbook.turn({
          width: this.isMobile()
            ? $(window).width()
            : this.calcHeight() * 2 * (this.imgWidth / this.imgHeight),
          height: this.isMobile()
            ? $(window).width() * (this.imgHeight / this.imgWidth)
            : this.calcHeight(),
          display: this.isMobile() ? 'single' : 'double',
          acceleration: this.isMobile() ? true : false,
          elevation: 500,
          duration: 1000,
          gradients: true,
          autoCenter: true,
          pages: this.totalPage,
          turnCorners: 'bl,br,tl,tr,l.r',
          when: {
            turning: (e, page, view) => {},
            turned: (e, page, view) => {},
          },
        })
      },
      swipeleft() {
        $('#next').click() //直接赋值视图不更新
      },
      swiperight() {
        $('.flipbook').turn('previous')
        $('#previous').click() //直接赋值视图不更新
      },
      listenerEvents() {
        $(window).resize(function () {
          window.location.reload()
        })
        $(document).keydown(function (e) {
          var esc = 27
          switch (e.keyCode) {
            case esc:
              $('.turn-viewport').zoom('zoomOut')
              e.preventDefault()
              break
          }
        })
      },
      turnPage(type) {
        if (this.isOddPage) {
          if (type == 'next') {
            if (this.currPage == this.totalPage) {
              console.log('没有下一页了')
              return
            }
            $('.flipbook').turn('next')
          }
          if (type == 'last') {
            if (this.currPage == this.totalPage) {
              console.log('没有下一页了')
              return
            }
            $('.flipbook').turn('page', this.totalPage)
          }
        }
        if (this.isEvenPage) {
          if (type == 'next') {
            if (this.isMobile()) {
              if (this.currPage == this.totalPage) {
                console.log('没有下一页了')
                return
              }
            } else {
              if (this.currPage == this.totalPage - 1) {
                console.log('没有下一页了')
                return
              }
            }
            $('.flipbook').turn('next')
          }
          if (type == 'last') {
            if (this.isMobile()) {
              if (this.currPage == this.totalPage) {
                console.log('没有下一页了')
                return
              }
              $('.flipbook').turn('page', this.totalPage)
            } else {
              if (this.currPage == this.totalPage - 1) {
                console.log('没有下一页了')
                return
              }
              $('.flipbook').turn('page', this.totalPage - 1)
            }
          }
        }
        if (type == 'first') {
          if (this.currPage == 1) {
            console.log('没有上一页了')
            return
          }
          $('.flipbook').turn('page', 1)
        }
        if (type == 'previous') {
          if (this.currPage == 1) {
            console.log('没有上一页了')
            return
          }
          $('.flipbook').turn('previous')
        }
        if (type == 'input') {
          const regular = /^[+]{0,1}(\d+)$/
          if (regular.test(this.showPage)) {
            let isHasPage = $('.flipbook').turn('hasPage', this.showPage)
            if (isHasPage) {
              $('.flipbook').turn('page', this.showPage)
            } else {
              console.log('该页不存在')
            }
          } else {
            console.log('请输入合法的数字')
            return
          }
        }
        this.showInputPage()
      },
      showInputPage() {
        console.log($.isTouch)
        this.currPage = $('.flipbook').turn('page')
        this.currPages = $('.flipbook').turn('view')
        if (this.currPage == 1) {
          this.resetInputPage()
        } else {
          if (this.isMobile()) {
            this.showPage = this.currPages[0] + '/' + this.totalPage
          } else {
            if (this.isEvenPage) {
              this.showPage =
                this.currPages[0] +
                '-' +
                this.currPages[1] +
                '/' +
                this.totalPage
            }
            if (this.isOddPage) {
              if (this.currPage == this.totalPage) {
                this.showPage = this.currPages[0] + '/' + this.totalPage
              } else {
                this.showPage =
                  this.currPages[0] +
                  '-' +
                  this.currPages[1] +
                  '/' +
                  this.totalPage
              }
            }
          }
        }
      },
      handleFocus() {
        this.showPageCopy = this.showPage
        this.showPage = ''
      },
      handleBlur() {
        if (!this.showPage) {
          this.showPage = this.showPageCopy
        }
        this.showPageCopy = ''
      },
      downLoad() {
        this.$emit('downLoad')
      },
      getImageSize(url) {
        return new Promise(function (resolve, reject) {
          let image = new Image()
          image.onload = function () {
            resolve({
              width: image.width,
              height: image.height,
            })
          }
          image.onerror = function () {
            reject(new Error('error'))
          }
          image.src = url
        })
      },
      resetInputPage() {
        this.isOddPage = this.totalPage % 2 == 0
        this.isEvenPage = !this.isOddPage
        this.currPage = 1
        if (this.isMobile) {
          this.currPages = [1]
        } else {
          this.currPages = [0, 1]
        }
        this.showPage = this.currPage + '/' + this.totalPage
      },
    },
  }
</script>
<style lang="scss" scoped>
  i {
    font-size: 24px;
    color: #ffffff;
    cursor: pointer;

    &:hover {
      font-weight: 700;
    }
  }

  .el-icon {
    color: #333;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 28px;
  }

  .btn-list {
    /deep/ {
      .el-input {
        width: 100px;
        margin: 0 10px;
        font-size: 14px;

        .el-input__inner {
          color: #333;
          padding: 0 10px;
        }

        .el-input__suffix {
          i {
            color: #333;
            font-size: 20px;
          }
        }
      }
    }
  }

  .ml500 {
    margin-left: -594.88px !important;
  }

  .mr500 {
    margin-left: 0 !important;
    margin-right: -594.88px !important;
  }
</style>
<style>
  @import '../../public/css/magazine.css';
</style>
